<template>
<div id="applogout" v-cloak>

    <b-container>       

    </b-container>
</div>
</template>

<script>

export default {
    name: 'applogout',  
    data: function () {
        return {};
    },
    created: function() {
        localStorage.removeItem('token');
        this.$router.push(`/ute`);
    }
}
</script>

